import React, { Suspense } from 'react';
import { IMatchComments } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchCommentsWrapper = React.lazy(() => import('./match-comments'));
export interface IDynamicMatchCommentsWrapper extends IComponentModel<IMatchComments> {
  live?: boolean;
}

const DynamicMatchComments = ({
  /* istanbul ignore next: default value on mandatory field */ model = {
    comments: [],
    firstCommentDate: '',
    lastCommentDate: '',
    competition: { seoName: '', customName: '' },
    homeTeam: { seoName: '', customName: '' },
    awayTeam: { seoName: '', customName: '' },
    matchStatus: '',
    url: '',
    isLive: false,
    nextLink: '',
    prevLink: '',
    newPostsCount: 0,
    updatesBadge: {
      isVisible: false,
      count: 0,
      onClick: () => {},
    },
  },
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  live = false,
}: IDynamicMatchCommentsWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MatchCommentsWrapper
      initialModel={validateModel(model) as IMatchComments}
      query={validateModel(query)}
      live={live}
    />
  </Suspense>
);

DynamicMatchComments.defaultProps = {
  live: false,
};

export default DynamicMatchComments;
